import { z } from "zod";
import { placeSchema } from "./place";

/** GET /interests 실측 응답. */
export const interestSchema = z.object({
  id: z.string(),
  tagId: z.string().nullable().optional(),
  categoryCode: z.string().nullable().optional(),
  region: z.string().nullable().optional(),
  notifyEventTypes: z.array(z.string()).default([]),
  notifyNewPlaces: z.boolean(),
  notifyEventDeadlines: z.boolean(),
  notifyStockUpdates: z.boolean(),
});
export type InterestDto = z.infer<typeof interestSchema>;

/** GET /interests/recommendations — 규칙 기반. AI 미사용 (P10). */
export const recommendationSchema = z.object({
  id: z.string(),
  name: z.string(),
  category: z.string(),
  addressLine: z.string(),
  score: z.number(),
});

/** GET /places/nearby — Place 요약 + distanceMeters. */
export const nearbyPlaceSchema = placeSchema.partial({ sourceLinks: true, tags: true })
  .extend({ distanceMeters: z.number() });
export const nearbyPayloadSchema = z.object({
  places: z.array(nearbyPlaceSchema).default([]),
  events: z.array(z.object({
    id: z.string(), name: z.string(), placeName: z.string().optional(),
    distanceMeters: z.number().optional(), endsAt: z.string().optional(),
  })).default([]),
});
